var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.96 184.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: .18px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #cc0202;\n        stroke-width: .18px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.81,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.81,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.09,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.81,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.54,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.81,
    y: 165.42,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.54,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.54,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.54,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.54,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.54,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.54,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.81,
    y: 9.81,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 155.7,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.27,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.27,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.27,
    y: 19.54,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 126.52,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.99,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.99,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 48.72,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.99,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.72,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.72,
    y: 126.52,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.72,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.72,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.72,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.72,
    y: 48.72,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.72,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.44,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 126.52,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 48.72,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.44,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.44,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 155.7,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.17,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.17,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.17,
    y: 19.54,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.89,
    y: 165.42,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.89,
    y: 155.7,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.89,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.89,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.89,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.89,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.89,
    y: 19.54,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.89,
    y: 9.81,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.62,
    y: 165.42,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.62,
    y: 175.15,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.62,
    y: 155.7,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.62,
    y: 126.52,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.62,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.62,
    y: 48.72,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.62,
    y: 19.54,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.62,
    y: 9.81,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.62,
    y: 0.09,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.42,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.42,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.15,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.42,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.7,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.42,
    y: 9.81,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.7,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.7,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.7,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.7,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.7,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.7,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.42,
    y: 165.42,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 19.54,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.97,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.97,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.97,
    y: 155.7,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 48.72,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.25,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.25,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 126.52,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.25,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.52,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.52,
    y: 48.72,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.52,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.52,
    y: 87.62,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.52,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.52,
    y: 126.52,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.52,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.79,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 48.72,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 126.52,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.79,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.79,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 19.54,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.07,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 38.99,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 58.44,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 77.89,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 97.34,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 116.79,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 136.25,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.07,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.07,
    y: 155.7,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.34,
    y: 9.81,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.34,
    y: 19.54,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.34,
    y: 29.27,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.34,
    y: 68.17,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.34,
    y: 107.07,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.34,
    y: 145.97,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.34,
    y: 155.7,
    width: 9.73,
    height: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.34,
    y: 165.42,
    width: 9.73,
    height: 9.73
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset7);
export default __webpack_public_path__ + "static/media/Asset7.a49f01f71c02ec1d8086cd87a39722bf.svg";
export { ForwardRef as ReactComponent };